const Star = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="star-06">
      <path
        id="Icon"
        d="M3.375 17.0908V13.3408M3.375 5.84082V2.09082M1.5 3.96582H5.25M1.5 15.2158H5.25M9.75 2.84082L8.44937 6.22247C8.23786 6.77239 8.1321 7.04735 7.96765 7.27863C7.82189 7.48362 7.6428 7.66271 7.43781 7.80847C7.20653 7.97292 6.93157 8.07868 6.38165 8.29019L3 9.59082L6.38165 10.8915C6.93157 11.103 7.20653 11.2087 7.43781 11.3732C7.6428 11.5189 7.82189 11.698 7.96765 11.903C8.1321 12.1343 8.23786 12.4093 8.44937 12.9592L9.75 16.3408L11.0506 12.9592C11.2621 12.4093 11.3679 12.1343 11.5324 11.903C11.6781 11.698 11.8572 11.5189 12.0622 11.3732C12.2935 11.2087 12.5684 11.103 13.1184 10.8915L16.5 9.59082L13.1184 8.29019C12.5684 8.07868 12.2935 7.97292 12.0622 7.80847C11.8572 7.66271 11.6781 7.48362 11.5324 7.27863C11.3679 7.04735 11.2621 6.77239 11.0506 6.22247L9.75 2.84082Z"
        stroke="#A4A7AE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Star;
